import { post } from "@insite/client-framework/Services/ApiService";

export interface HelpPlacingOrderFormParamter {
   
    Name: string;
    CompanyName: string;
    Email: string;
    Message: string;
    onSuccess?: () => void;
}

export interface HelpPlacingOrderFormModel  {}

const createHelpPlacingOrderForm = "api/v2/email/helpplacinganorder";

export async function helpPlacingOrderFormService(parameter: HelpPlacingOrderFormParamter) {
    const response = await post<HelpPlacingOrderFormModel>(createHelpPlacingOrderForm, parameter);
    return response;
}
